let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("iSut4")).then(() => parcelRequire('5zKBB'));